module.exports = __webpack_public_path__ + "static/computer-vision-configure-baea61bbdc1f3d1cdc2a3393d9402ec2.png";